import type { Kfrabstimmzeile } from './typen'

/*
  Die Ausnahmen der Kapitalflussrechnung (2.8 Abschnitt 13.51, R1675–R1677) —
  was keine Zeile nennen darf, gepflegt unten in der Abstimmung gegen die
  Bewegungsbilanz. Die Rechnung liefert je Konto und Bewegungsart, was
  ausgenommen ist und welche Ausnahmen es nennen; hier wird daraus der Block
  unter der Tabelle gebildet. Gerechnet wird nichts Neues: Jede Zahl ist eine
  Summe der Zeilen darüber.
*/

/** Auf den Cent, damit eine Summe aus Kommazahlen nicht um ein Tausendstel danebensteht. */
function cent(wert: number): number {
  return Math.round(wert * 100) / 100
}

/**
 * **Was eine Ausnahme je Konto nennt** (R1676) — Soll-positiv wie die Spalte
 * *Ausgenommen*. Nennen zwei Ausnahmen dieselbe Bewegung, trägt jede ihren
 * Teil; die Spalte zählt beide und weicht deshalb ab.
 */
export function ausnahmekonten(
  abstimmung: Kfrabstimmzeile[],
  schluessel: string,
): { konto: string; betrag: number }[] {
  return abstimmung
    .map((a) => ({
      konto: a.konto,
      betrag: cent(
        (a.bewegungsarten ?? [])
          .filter((b) => b.ausnahmen?.includes(schluessel))
          .reduce((summe, b) => summe + (b.ausgenommen ?? 0) / (b.ausnahmen?.length ?? 1), 0),
      ),
    }))
    .filter((k) => k.betrag !== 0)
}

/** Eine Gegenprobe: was von einer Bewegungsart ausgenommen ist und was sie auf dem Fonds bewegt (R1677). */
export type Gegenprobe = { bewegungsart: string; ausgenommen: number; fonds: number }

/**
 * **Die Gegenprobe je Bewegungsart einer Ausnahme** (R1677), über den Zeitraum
 * der Abstimmung — beide Seiten Soll-positiv. Ein Kreiszugang geht in sich
 * auf: Was außerhalb des Fonds ausgenommen ist, und die Kasse, die mitkam,
 * ergeben zusammen null. Nur Bewegungsarten, an denen etwas steht.
 */
export function gegenproben(abstimmung: Kfrabstimmzeile[], arten: string[]): Gegenprobe[] {
  return arten
    .map((art) => {
      let ausgenommen = 0
      let fonds = 0
      for (const a of abstimmung) {
        for (const b of a.bewegungsarten ?? []) {
          if (b.bewegungsart !== art) {
            continue
          }
          if (a.fonds) {
            fonds += b.bewegungsbilanz
          } else {
            ausgenommen += b.ausgenommen ?? 0
          }
        }
      }
      return { bewegungsart: art, ausgenommen: cent(ausgenommen), fonds: cent(fonds) }
    })
    .filter((p) => p.ausgenommen !== 0 || p.fonds !== 0)
}

/** Ob die Gegenprobe aufgeht — und wenn nicht, um wie viel (R1677). */
export function gegenprobenrest(p: Gegenprobe): number {
  return cent(p.ausgenommen + p.fonds)
}
